import { useEffect } from 'react';
import { AppDispatch, RootState } from '../../../redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSchoolClassesConfig } from '../../../redux/slices/SchoolConfigSlice';

export const useSchoolClassesConfigHook = (school?: string) => {
  const dispatch: AppDispatch = useDispatch();

  const { schoolClassesConfig } = useSelector(
    (state: RootState) => state.schoolConfig
  );
  const { user: loggedInUser } = useSelector(
    (state: RootState) => state.profile
  );

  useEffect(() => {
    const schoolToFetch = school || loggedInUser?.school;
    if (schoolToFetch) {
      dispatch(fetchSchoolClassesConfig(schoolToFetch));
    }
  }, [school, loggedInUser?.school, dispatch]);

  const gradeOptions = (schoolClassesConfig?.grades || []).map(
    (grade: string) => ({
      label: grade,
      value: grade
    })
  );

  const divisionOptions = (schoolClassesConfig?.divisions || []).map(
    (division: string) => ({
      label: division,
      value: division
    })
  );

  const sectionOptions = (schoolClassesConfig?.sections || []).map(
    (section: string) => ({
      label: section,
      value: section
    })
  );

  return {
    schoolClassesConfig,
    gradeOptions,
    divisionOptions,
    sectionOptions,
    loggedInUser
  };
};
